import { Component, Input } from '@angular/core';
import { Direction } from '../../../models/direction.enum';
import { LineItem } from '../../../models/lineitem';

@Component({
  selector: 'detail-authority-card',
  templateUrl: './detail-authority-card.component.html',
  styleUrls: ['./detail-authority-card.component.scss']
})
export class DetailAuthorityCardComponent {
  @Input() lineItem: LineItem;
  Direction = Direction;
}
